<template>
  <v-card>
    <v-form>
      <form-header
        :form="form"
        :title="$lang('reservations.title_create')"
        tour="reservation-create--multiple-form"
      >
        <template v-slot:left-buttons>
          <v-btn icon dark @click="cancel()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </template>
        <template v-slot:toolbar-items>
          <v-btn dark text @click="submit()" :loading="loading">{{ $lang("main.crud.create") }}</v-btn>
        </template>
      </form-header>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12" xs="12" md="6">
              <v-row>
                <v-col cols="12" xs="12" md="12">
                  <c-properties-autocomplete
                    v-model="form.property_id"
                    :label="$lang('reservations.fields.property')"
                    :error="!!validation.property_id"
                    :error-messages="!!validation.property_id ? validation.property_id : []"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" xs="12" md="12">
                  <v-client
                    :errors="validation.client_id"
                    :property-id="form.property_id"
                    @changed="client => { form.client_id = client.id }"
                  />
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" xs="12" md="6">
              <v-row>
                <v-col cols="12" xs="12" md="6">
                  <v-date
                    v-model="form.start_date"
                    prepend-icon="mdi-airplane-landing"
                    scrollable
                    :label="$lang('reservations.fields.start_date')"
                    :error="!!validation.start_date"
                    :error-messages="!!validation.start_date ? validation.start_date : []"
                  />
                </v-col>
                <v-col cols="12" xs="12" md="6">
                  <v-date
                    v-model="form.end_date"
                    prepend-icon="mdi-airplane-takeoff"
                    scrollable
                    :label="$lang('reservations.fields.end_date')"
                    :error="!!validation.end_date"
                    :error-messages="!!validation.end_date ? validation.end_date : []"
                  />
                </v-col>
                <v-col cols="12" xs="12" md="12">
                  <v-text-field
                    v-model="form.arrival_time"
                    prepend-icon="mdi-clock"
                    :label="$lang('reservations.fields.arrival_time')"
                    type="time"
                    :error="!!validation.arrival_time"
                    :error-messages="!!validation.arrival_time ? validation.arrival_time : []"
                  />
                </v-col>
                <v-col cols="12" xs="12" md="6">
                  <v-textarea
                    v-model="form.internal_note"
                    :label="$lang('reservations.fields.internal_note')"
                    filled
                    :error="!!validation.internal_note"
                    :error-messages="!!validation.internal_note ? validation.internal_note : []"
                  />
                </v-col>
                <v-col cols="12" xs="12" md="6">
                  <v-textarea
                    v-model="form.service_note"
                    :label="$lang('reservations.fields.service_note')"
                    filled
                    :error="!!validation.service_note"
                    :error-messages="!!validation.service_note ? validation.service_note : []"
                  />
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-select
                :items="$in('ConstReservationPaymentMethods')"
                v-model="form.payment_method"
                :label="$lang('reservations.fields.payment_method')"
                prepend-icon="mdi-piggy-bank"
                :error="!!validation.payment_method"
                :error-messages="!!validation.payment_method ? validation.payment_method : []"
              />
            </v-col>
            <v-col>
              <v-row>
                <v-col>
                  <v-boolean
                    v-model="form.skip_messages"
                    :label="$lang('reservations.labels.skip_messages')"
                  />
                </v-col>
                <v-col>
                  <v-color-picker-button
                    v-model="form.color"
                  />
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <!-- <v-row>
            <v-col cols="12" xs="12" md="6">
              <v-btn @click="openPromotions()" block class="mt-2">{{ $lang('reservations.promotions.title') }}</v-btn>
            </v-col>
          </v-row> -->
          <v-row>
            <v-col cols="12" xs="12" md="12">
              <v-simple-table dense>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left" style="width: 15%">{{ $lang('reservations.fields.unit') }}</th>
                      <th class="text-left" style="width: 15%">{{ $lang('reservations.fields.room_type') }}</th>
                      <th class="text-left" style="width: 15%">{{ $lang('reservations.fields.guests') }}</th>
                      <th class="text-left" style="width: 15%">{{ $lang('reservations.fields.discount') }}</th>
                      <th class="text-left" style="width: 15%">{{ $lang('reservations.fields.avg_night_amount') }}</th>
                      <th class="text-left" style="width: 15%">{{ $lang('reservations.fields.amount') }}</th>
                      <th class="text-center" style="width: 10%">{{ $lang('main.crud.actions') }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in form.items" :key="index">
                      <td>
                        <v-autocomplete
                          @change="unitChanged(index)"
                          v-model="item.unit_id"
                          prepend-icon="mdi-bed"
                          :items="dataUnits[index] || []"
                          item-text="name"
                          item-value="id"
                          :error="!!validation[`items.${index}.unit_id`]"
                          :error-messages="!!validation[`items.${index}.unit_id`] ? validation[`items.${index}.unit_id`] : []"
                          dense
                        >
                          <template v-slot:item="{ item: unit }">
                            <v-list-item-content>
                              <v-list-item-title>{{ unit.name }}</v-list-item-title>
                              <v-list-item-subtitle>
                                <v-chip :color="unit.unit_category.color" class="white--text" x-small label>
                                  <v-icon color="white" class="mr-1" x-small>mdi-shape</v-icon>{{ unit.unit_category.name }}
                                </v-chip>
                              </v-list-item-subtitle>
                            </v-list-item-content>
                          </template>
                          <template v-slot:no-data>
                            {{ $lang('reservations.labels.no_units_available') }}
                          </template>
                        </v-autocomplete>
                      </td>
                      <td>
                        <v-autocomplete
                          @change="roomTypeChanged(index)"
                          v-model="item.room_type_id"
                          prepend-icon="mdi-office-building"
                          :items="dataRoomTypes[index] || []"
                          item-text="name"
                          item-value="id"
                          :error="!!validation[`items.${index}.room_type_id`]"
                          :error-messages="!!validation[`items.${index}.room_type_id`] ? validation[`items.${index}.room_type_id`] : []"
                          dense
                        />
                      </td>
                      <td>
                        <v-text-field
                          v-model="item.guests"
                          prepend-icon="mdi-human-male"
                          :error="!!validation[`items.${index}.guests`]"
                          :error-messages="!!validation[`items.${index}.guests`] ? validation[`items.${index}.guests`] : []"
                          type="number"
                          dense
                        ></v-text-field>
                      </td>
                      <td>
                        <v-tooltip top v-if="!!item.discount">
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              v-on="on"
                              readonly
                              v-model="item.discount"
                              :suffix="item.currency"
                              :error="!!validation[`items.${index}.discount`]"
                              :error-messages="!!validation[`items.${index}.discount`] ? validation[`items.${index}.discount`] : []"
                              dense
                            ></v-text-field>
                          </template>
                          <span>{{item.applied_promotion}}</span>
                        </v-tooltip>
                      </td>
                      <td>
                        <v-text-field
                          @change="amountPerNightChanged(index)"
                          v-model="item.amount_per_night"
                          :suffix="item.currency"
                          :error="!!validation[`items.${index}.amount_per_night`]"
                          :error-messages="!!validation[`items.${index}.amount_per_night`] ? validation[`items.${index}.amount_per_night`] : []"
                          dense
                        ></v-text-field>
                      </td>
                      <td>
                        <v-text-field
                          @change="amountChanged(index)"
                          v-model="item.amount"
                          :suffix="item.currency"
                          :error="!!validation[`items.${index}.amount`]"
                          :error-messages="!!validation[`items.${index}.amount`] ? validation[`items.${index}.amount`] : []"
                          dense
                        ></v-text-field>
                      </td>
                      <td>
                        <div class="text-right">
                          <v-icon @click="addItem()" v-if="index === form.items.length - 1" color="success">mdi-plus</v-icon>
                          <v-icon @click="removeItem(index)" v-if="form.items.length > 1" color="error">mdi-minus</v-icon>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-form>

    <!-- <v-dialog v-model="isOpenPromotions" transition="dialog-bottom-transition" width="30%">
      <promotions-form
        v-if="isOpenPromotions"
        :options="{
          end_date: form.end_date,
          start_date: form.start_date,
          property_id: form.property_id,
        }"
        @close="closePromotions"
        @applied="promotionApplied"
      />
    </v-dialog> -->
  </v-card>
</template>

<script>
  import { mapState } from "vuex";
  import MixpanelEvents from "@/constants/events";

  import {
    CREATE_RESERVATIONS_MULTIPLE,
    CREATE_RESERVATIONS_MULTIPLE_RESET
  } from "@/store/reservations/actions";

  import {
    GET_UNITS_COLLECTION,
  } from "@/store/units/actions";

  import {
    GET_BOOKING_ENGINE_ROOM_TYPES,
  } from "@/store/booking-engine/actions";

  import formable from "@/mixins/formable";
  import prices from "@/pages/reservations/mixins/prices";

  import VClient from "@/components/widgets/VClient";

  const itemInterface = {
    property_id: null,
    unit_id: null,
    room_type_id: null,
    amount: null,
    discount: null,
    amount_per_night: null,
    amount_details: null,
  };

  export default {
    name: "CreationMultipleForm",
    components: {
      VClient,
    },
    mixins: [
      prices,
      formable,
    ],
    data() {
      return {
        form: {
          items: [
            { ...itemInterface }
          ],
          end_date: null,
          start_date: null,
        },
        dataUnits: [],
        dataRoomTypes: []
      }
    },
    methods: {
      resetAction() {
        return CREATE_RESERVATIONS_MULTIPLE_RESET;
      },
      submitAction() {
        return CREATE_RESERVATIONS_MULTIPLE;
      },
      submitActionOptions() {
        let data = { ...this.form };

        if (!data.items.length) {
          delete data['items'];
        }

        data.confirm = true;
        data.withSingleValidation = true;
        data.status = this.$const('ConstReservationStatuses', 'CONFIRMED');

        return data;
      },
      track() {
        this.$monitorService.track(MixpanelEvents.MULTIPLE_RESERVATION_CREATED);
      },
      addItem() {
        this.form.items.push({ ...itemInterface });
        this.refreshData();
      },
      removeItem(index) {
        this.form.items.splice(index, 1);
        this.refreshData();
      },
      getUnits(filters) {
        filters = filters || {};
        filters = {
          ...filters,
          sortBy: [
            {
              field: 'property_id',
              order: 'asc'
            },
            {
              field: 'position',
              order: 'asc'
            }
          ],
          _data: {
            selects: [
              'id',
              'name',
              'property_id',
              'unit_category_id',
            ],
            relations: {
              property: {
                selects: [
                  'id',
                  'currency',
                ]
              },
              unit_category: {
                selects: [
                  'id',
                  'name',
                  'color'
                ]
              }
            }
          }
        };

        if (this.form.property_id) {
          filters.property_id = this.form.property_id;
        }
        if (this.form.end_date && this.form.start_date) {
          filters.available = {
            end_date: this.form.end_date,
            start_date: this.form.start_date,
          };
        }

        return this.$store.dispatch(GET_UNITS_COLLECTION, filters);
      },
      getRoomTypes(filters) {
        filters = filters || {};

        if (this.form.property_id) {
          filters.property_id = this.form.property_id;
        }
        if (!this.form.end_date || !this.form.start_date) {
          return;
        }

        filters.end_date = this.form.end_date;
        filters.start_date = this.form.start_date;

        return this.$store.dispatch(GET_BOOKING_ENGINE_ROOM_TYPES, filters);
      },
      refreshData() {
        this.dataUnits = [];
        this.dataRoomTypes = [];

        this.form.items.map((item, index) => {
          let unit = null;
          let roomType = null;

          this.dataUnits[index] = [ ...this.units ].filter(_unit => {
            const isMy = item.unit_id === _unit.id;
            const isInProperty = this.form.property_id ? _unit.property_id === this.form.property_id : true;
            const isNotInItems = this.form.items.filter(_item => _item.unit_id === _unit.id).length === 0;

            if (isMy) {
              unit = _unit;
            }

            return isInProperty && (isMy || isNotInItems);
          });

          this.dataRoomTypes[index] = [ ...this.roomTypes ].filter(_room_type => {
            const isMy = item.room_type_id === _room_type.id;
            const isMyGroup = unit && _room_type.unit_category_id === unit.unit_category_id;

            if (isMy) {
              roomType = _room_type;
            }

            return isMy || isMyGroup;
          });

          if (unit) {
            item.currency = unit.property.currency;
          } else {
            delete item['currency'];
          }

          if (roomType) {
            item.guests = roomType.guests;

            if (!item.is_amount_changed) {
              item.amount = this.getRoomTypeAmount(roomType);
              item.discount = this.getRoomTypeDiscount(roomType);
              item.amount_details = this.getRoomTypeAmountDetails(roomType);
              item.amount_per_night = this.getRoomTypeAmountPerNight(roomType);
              item.applied_promotion = this.getAppliedPromotion(roomType);
            }
          } else {
            delete item['guests'];
            delete item['amount'];
            delete item['amount_details'];
          }
        });
      },
      getRoomTypeAmount(roomType) {
        let amount = 0;

        const details = this.getRoomTypeAmountDetails(roomType);

        if (!details) {
          return amount;
        }

        details.map(detail => {
          amount += detail.amount;
        });

        return amount.toFixed(2);
      },
      getRoomTypeAmountPerNight(roomType) {
        return this.getAmountPerNight(this.getRoomTypeAmount(roomType));
      },
      getRoomTypeDiscount(roomType) {
        let discount = 0;

        const details = this.getRoomTypeAmountDetails(roomType);

        if (!details) {
          return discount;
        }

        details.map(detail => {
          discount += detail.discount;
        });

        return discount.toFixed(2);
      },
      getRoomTypeDiscountPerNight(roomType, rate) {
        let amount = 0;

        if (!roomType.property.best_promotion) {
          return amount;
        }

        let promotion = roomType.property.best_promotion;
        let inPromotion = promotion.room_types.some((item) => {
          return item.id === roomType.id
        });

        if (!inPromotion && !promotion.is_all_room_types) {
          return amount;
        }

        amount = parseFloat(rate.amount);

        if (promotion.discount_type === this.$const('ConstDiscountTypes', 'VALUE')) {
          amount = parseFloat(promotion.discount);
        } else {
          amount = parseFloat(amount) * promotion.discount / 100;
        }

        return amount.toFixed(2);
      },
      getRoomTypeAmountDetails(roomType) {
        let details = [];

        if (!roomType.rates || !roomType.rates.length) {
          return;
        }

        roomType.rates.map((rate) => {
          const amount = parseFloat(rate.amount);
          const discount = parseFloat(this.getRoomTypeDiscountPerNight(roomType, rate));

          details.push({
            date: rate.date,
            discount: discount,
            amount: amount - discount,
          });
        });

        return details;
      },
      getAmountPerNight(amount) {
        let endDate = this.$moment(this.form.end_date);
        let startDate = this.$moment(this.form.start_date);
        let nights = this.$dateDiffInDays(startDate, endDate);

        let total = parseFloat(amount);

        return !isNaN(total/nights) ? (total/nights).toFixed(2) : 0;
      },
      getAppliedPromotion(roomType){
        if (!roomType.property.best_promotion) {
          return null;
        }

        let promotion = roomType.property.best_promotion;
        let inPromotion = promotion.room_types.some((item) => {
          return item.id === roomType.id
        });

        if (!inPromotion && !promotion.is_all_room_types) {
          return null;
        }

        return `${promotion.name} - ${this.$constText('ConstPropertyPromotionTypes', promotion.type)}`;
      },
      unitChanged(index) {
        const unitId = this.form.items[index].unit_id;
        const unit = this.units.find((item) => {
          return item.id === unitId;
        })

        this.$set(this.form.items, index, {
          ...itemInterface,
          unit_id: unitId,
          property_id: unit.property_id
        });

        this.refreshData();
      },
      roomTypeChanged(index) {
        const unitId = this.form.items[index].unit_id;
        const roomTypeId = this.form.items[index].room_type_id;
        const unit = this.units.find((item) => {
          return item.id === unitId;
        })

        this.$set(this.form.items, index, {
          ...itemInterface,
          unit_id: unitId,
          room_type_id: roomTypeId,
          property_id: unit.property_id
        });

        this.refreshData();
      },
      amountChanged(index) {
        this.form.items[index].amount_details = [];
        this.form.items[index].is_amount_changed = true;
        this.form.items[index].amount_per_night = parseFloat(this.getAmountPerNight(this.form.items[index].amount));
        this.form.items[index].discount_per_night = parseFloat(this.getAmountPerNight(this.form.items[index].discount));

        let endDate = this.$moment(this.form.end_date);
        let startDate = this.$moment(this.form.start_date);

        do {
          this.form.items[index].amount_details.push({
            date: this.$toDateString(startDate),
            amount: parseFloat(this.form.items[index].amount_per_night),
            discount: parseFloat(this.form.items[index].discount_per_night),
          });

          startDate.add(1, 'days');
        } while (endDate.isAfter(startDate));
      },
      amountPerNightChanged(index) {
        this.form.items[index].amount = 0;
        this.form.items[index].amount_details = [];
        this.form.items[index].is_amount_changed = true;
        this.form.items[index].discount_per_night = parseFloat(this.getAmountPerNight(this.form.items[index].discount));

        let endDate = this.$moment(this.form.end_date);
        let startDate = this.$moment(this.form.start_date);

        do {
          this.form.items[index].amount_details.push({
            date: this.$toDateString(startDate),
            amount: parseFloat(this.form.items[index].amount_per_night),
            discount: parseFloat(this.form.items[index].discount_per_night),
          });

          this.form.items[index].amount += parseFloat(this.form.items[index].amount_per_night);

          startDate.add(1, 'days');
        } while (endDate.isAfter(startDate));

        this.form.items[index].amount = this.form.items[index].amount.toFixed(2);
      },
      promotionApplied(promotion) {
        this.appliedPromotion = promotion;

        this.form.items.map(item => {
          item.amount_details.map(detail => {
            const oldAmount = detail.amount;
            detail.amount = this.calculateSinglePrice(detail, {
              promotion: this.appliedPromotion
            });
            detail.discount = oldAmount - detail.amount;
          });
        });

        this.form.relations = [
          {
            name: 'reservation_promotions',
            data: [this.appliedPromotion.id]
          }
        ];
      }
    },
    computed: {
      initialized() {
        return !this.unitsRequest.loading &&
          !this.roomTypesRequest.loading;
      },
      ...mapState({
        loading: state => state.reservations.creationMultipleRequest.loading,
        validation: state => state.reservations.creationMultipleRequest.errors,
        units: state => state.units.getCollectionRequest.collection,
        unitsRequest: state => state.units.getCollectionRequest,
        roomTypes: state => state.bookingEngine.getRoomTypesRequest.data.collection || [],
        roomTypesRequest: state => state.bookingEngine.getRoomTypesRequest,
      })
    },
    watch: {
      initialized(yes) {
        if (yes) {
          this.refreshData();
        }
      },
      'form.property_id'() {
        this.getUnits();
        this.getRoomTypes();
      },
      'form.end_date'() {
        this.getUnits();
        this.getRoomTypes();
      },
      'form.start_date'() {
        const startDate = this.$moment(this.form.start_date);

        if (!this.form.end_date) {
          this.form.end_date = this.$toDateString(startDate.add(1, 'days'));
          return;
        }

        const endDate = this.$moment(this.form.end_date);

        if (startDate.isSameOrAfter(endDate)) {
          this.form.end_date = this.$toDateString(startDate.add(1, 'days'));
        } else {
          this.getUnits();
          this.getRoomTypes();
        }
      },
    }
  };
</script>

<style scoped>
</style>
